import { BehaviorSubject } from "rxjs";
import { autenticar, obterUsuario, obterFotoUsuario } from "./services/api";
import { obterIdUsuarioJwt } from "./helpers/obterIdUsuarioJwt";
import { AuthProvider, useAuth, authSubject } from "./hooks/AuthKeycloak";
export * from "./hooks/PermissionsContext";

export const auth$ = new BehaviorSubject({
  sessionToken: localStorage.getItem("sessionToken")
    ? localStorage.getItem("sessionToken")
    : null,
  error: "",
  pending: false,
});

const GET_LOGGED_IN = async (usuario, senha) => {
  auth$.next({
    sessionToken: null,
    error: "",
    pending: true,
  });

  try {
    const response = await autenticar({
      usuario,
      senha,
    });

    const token = response.data.retorno;

    localStorage.setItem("sessionToken", token);

    const idUsuario = obterIdUsuarioJwt(token);

    const usuarioJwt = await obterUsuario(idUsuario, token);

    if (usuarioJwt.data.retorno) {
      try {
        const foto = await obterFotoUsuario(idUsuario, token);

        if (foto.data.retorno) {
          localStorage.setItem("userAvatar", foto.data.retorno);
        }
      } catch (ex) {
        console.error("Erro ao obter foto do usuário:", ex);
      }

      localStorage.setItem("user", JSON.stringify(usuarioJwt.data.retorno));
    }

    return {
      sessionToken: token,
      error: "",
      pending: false,
    };
  } catch (ex) {
    return {
      sessionToken: null,
      error: "Usuário ou senha inválidos",
      pending: false,
    };
  }
};

export async function login(usuario, senha) {
  if (!auth$.value.pending) {
    const autenticacao = await GET_LOGGED_IN(usuario, senha);

    auth$.next(autenticacao);
  }
}

export function logout() {
  localStorage.removeItem("sessionToken");
  localStorage.removeItem("user");
  localStorage.removeItem("userAvatar");
  auth$.next({
    sessionToken: null,
    error: "",
    pending: false,
  });
}

const keycloakRoutes = ["/documento", "/login/banrisul", "/configuracoes", "/usuarios"];

export const isKeycloakRoute = () => {
  const pathname = location.pathname;

  return keycloakRoutes.some((route) => {
    return pathname === route || pathname.startsWith(route);
  });
};

export { AuthProvider, useAuth, authSubject };
